var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.6667 0H8.33333C3.73167 0 0 3.73167 0 8.33333V31.6667C0 36.2683 3.73167 40 8.33333 40H31.6667C36.27 40 40 36.2683 40 31.6667V8.33333C40 3.73167 36.27 0 31.6667 0ZM18.3333 16.9983L12.2667 20L18.3333 22.9933V26.6667L8.33333 21.775V18.2233L18.3333 13.3333V16.9983ZM31.6667 21.775L21.6667 26.6667V22.9933L27.7333 20L21.6667 16.9983V13.3333L31.6667 18.225V21.775Z","fill":"#4D13D1"}));
}

Code.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Code;

Code.default = Code;
